'use strict';

export default {
  default: {
    title: 'You are being logged out',
  },
  sessionExpired: {
    title: 'Your session has expired',
    description: 'Unfortunately your session is expired and you’ve been logged out. You will be redirected to the home page shortly…',
    popup: true,
  },
};



// WEBPACK FOOTER //
// ./client/models/global/logout.js